<template>
    <edit></edit>
</template>
<script>
    import edit from './platform_rule_edit.vue'

    export default {
        name: 'platform_rule_add',

        components: {
            edit
        }
    }
</script>
